import React, { Component } from 'react'
import './index.less'
import Classic from './Classic'
import Master from './Master'
import Quick from './Quick'
import langM from './lang'
import { getlang, setlang } from 'src/helper/getlang'

export default class index extends Component {
  constructor(props) {
    super(props)
  }
  state = {
    tabState: 1,
    position: 0.2,
    lang:langM.en,
    languega:'en',
  }
  async componentWillMount() {
    let { language } = this.props.location.query
    language =await getlang(language)
    this.setState({
      lang: setlang(language, langM),
      language: language
    })
  }
  changeTab(val, e) {
    this.setState({
      tabState: val
    })
    if (val == 1) {
      if (this.state.tabState == 2) {
        this.setState({
          position: 0.2
        })
      }
      if (this.state.tabState == 3) {
        this.setState({
          position: 0.2
        })
      }
    }
    if (val == 2) {
      if (this.state.tabState == 1) {
        this.setState({
          position: 2.3
        })
      }
      if (this.state.tabState == 3) {
        this.setState({
          position: 2.3
        })
      }
    }
    if (val == 3) {
      if (this.state.tabState == 1) {
        this.setState({
          position: 4.45
        })
      }
      if (this.state.tabState == 2) {
        this.setState({
          position: 4.45
        })
      }
    }
  }
  componentDidMount() {
  }
  render() {
    const { tabState, lang } = this.state
    const ludoTabItem = [
      {
        type: lang.classic
      },
      {
        type: lang.master
      },
      {
        type: lang.quick
      },
    ]
    return (
      <div className='ludo-rule-wrap'>
        <div className="ludo-rule-title">{lang.rule}</div>
        <div className="ludo-tab" style={{ backgroundPosition: `${this.state.position}rem center` }}>
          {
            ludoTabItem.map((item, index) => {
              return (
                <div
                  key={index}
                  onClick={this.changeTab.bind(this, index + 1)}
                  className={`ludo-tab-item ${tabState == index + 1 ? "ludo-tab-item-active" : ""}`}>
                  {item.type}
                </div>
              )
            })
          }
        </div>
        {tabState == 1 && <Classic />}
        {tabState == 2 && <Master />}
        {tabState == 3 && <Quick />}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/ludo/ludorule/index.js